/**
* Order
*/
module.config(['$stateProvider', 'urls', function ($stateProvider, urls) {
    'use strict';
    $stateProvider
        .state('order', {
            url: '/' + urls.order.fr, // TODO : when multilang, change this to something dynamic
            abstract: true,
            resolve: {
                cart: function ($q, cart) {
                    // console.log('order: retrieve cart');

                    // retrieve current cart
                    var deferred = $q.defer();
                    if (cart.quantity > 0) {
                        deferred.resolve(cart);
                    } else {
                        // prepare rerouting (see app.js)
                        deferred.reject({ status: 'ORDER_CART_EMPTY' });
                    }
                    return deferred.promise;
                },
                auth: function ($q, profile) {
                    // console.log('order: retrieve user');

                    // retrieve current user status
                    var deferred = $q.defer();
                    profile.claim().then(function (authorization) {
                        deferred.resolve(authorization);
                    }).catch(function (error) {
                        // prepare rerouting (see app.js)
                        deferred.reject({ status: 'ORDER_USER_ERROR' });
                    });
                    return deferred.promise;
                }
            },
            controller: ['$rootScope', '$scope', 'headermanager', '$filter', 'cart', 'auth', 'profile', 'formPattern', function ($rootScope, $scope, headermanager, $filter, $cart, auth, $profile, formPattern) {

                var steps = [];
                $scope.formPattern = formPattern;
                // order.user is not order.login parent state but doing so allow order.user & order.login to be identified as one step (for "current step" highlight)

                if (!auth.authenticated || !$profile.info.field_civilite || !$profile.info.field_nom || !$profile.info.field_prenom || !$profile.info.field_adresse || !$profile.info.field_cp || !$profile.info.field_date_de_naissance || !$profile.info.field_pays || !$profile.info.field_ville || !$profile.info.field_nationalite || (!$profile.info.field_tel_fixe && !$profile.info.field_tel_portable)) {
                    steps.push({ label: $filter('translate')('order.identification'), state: 'order.login', parentState: 'order.user' });
                }
                if ($cart.internships.length) {
                    steps.push({ label: $filter('translate')('order.participants'), state: 'order.participants' });
                }
                steps.push({ label: $filter('translate')('order.payment'), state: 'order.payment' }, { label: $filter('translate')('order.confirmation'), state: 'order.confirmation' });

                // customize header
                headermanager.customize({
                    type: 'alternate',
                    filled: true,
                    tunnel: {
                        title: {
                            label: $filter('translate')('common.cart'), state: 'cart'
                        },
                        steps: steps
                    }
                });

                // root title handler
                $rootScope.titlePanel = {
                    title: '',
                    subtitle: ''
                };
                var titlepanelWatcher = $rootScope.$watch('titlePanel', function (value) {
                    $scope.title = {
                        title: value.title,
                        subtitle: value.subtitle
                    };
                });
                $scope.$on('$destroy', function () {
                    titlepanelWatcher();
                });
                $rootScope.teaserPanel = {
                    css: '',
                    body: ''
                };
                var teaserPanelWatcher = $rootScope.$watch('teaserPanel', function (value) {
                    $scope.teaser = value;

                });
                $scope.$on('$destroy', function () {
                    teaserPanelWatcher();
                });
            }],
            templateUrl: 'src/views/order/order_layout.html'
        })
        .state('order.login', {
            url: '',
            params: {
                errorMessage: null
            },
            resolve: {
                state: ['$q', 'auth', 'profile', function ($q, auth, $profile) {
                    // console.log('order.login: state', auth);

                    // Step is needed only if user is not already identified
                    var deferred = $q.defer();
                    if (auth.authenticated) {
                        if ($profile.info.field_nom && $profile.info.field_civilite && $profile.info.field_nom && $profile.info.field_prenom && $profile.info.field_adresse && $profile.info.field_cp && $profile.info.field_date_de_naissance && $profile.info.field_pays && $profile.info.field_ville && $profile.info.field_nationalite && ($profile.info.field_tel_fixe || $profile.info.field_tel_portable)) {
                            // prepare rerouting (see app.js)
                            deferred.reject({ status: 'ORDER_LOGIN__ALREADY' });
                        } else {
                            // missing account info
                            deferred.reject({ status: 'ORDER_LOGIN__MISSING_INFO' });
                        }
                    } else {
                        deferred.resolve();
                    }
                    return deferred.promise;
                }]
            },
            views: {
                content: {
                    controller: ['$scope', '$rootScope', '$filter', '$state', '$stateParams', 'profile', 'drupal', 'moment', 'tools', 'formPattern','utils', function ($scope, $rootScope, $filter, $state, $stateParams, $profile, $drupal, moment, $tools, formPattern, utils) {
                        $rootScope.titlePanel = {
                            title: $filter('translate')('order.identification'),
                            subtitle: ''
                        };
                        $scope.formPattern = formPattern;

                        $scope.tools = $tools;
                        $scope.loading = false;

                        $scope.errors = {
                            message: $stateParams.errorMessage
                        };

                        $scope.onSubmit = function() {
                            $scope.loading = true;
                        }

                        $scope.onFinally = function() {
                            $scope.loading = false;
                        }

                        $scope.onLoginSuccess = function() {
                            // console.log('order:login:auth(r):', r);
                            $profile.claim().then(function () {
                                if ($profile.authorization.authenticated) {
                                    //complete info
                                    if ($profile.info.field_nom && $profile.info.field_civilite && $profile.info.field_nom && $profile.info.field_prenom && $profile.info.field_adresse && $profile.info.field_cp && $profile.info.field_date_de_naissance && $profile.info.field_pays && $profile.info.field_ville && $profile.info.field_nationalite && ($profile.info.field_tel_fixe || $profile.info.field_tel_portable)) {
                                        $state.go('order.participants');
                                    } else {
                                        $state.go('order.user', { existing: true });
                                    }
                                } else {
                                    throw { message: $filter('translate')('account.unknown') };
                                }
                            }).catch(function (err) {
                                $scope.onError(err);
                            });
                        }
                        $scope.optionsCivility = [
                            { text: $filter('translate')('form.male'), value: 'M.' },
                            { text: $filter('translate')('form.female'), value: 'Mme' }
                        ];

                        $scope.onError = function(err) {
                            // console.log('order:login:Error:', error);
                            $scope.hasError = true;
                        }

                        // prepare new user form
                        $scope.user = {
                            email: '',
                            pass: '',
                            pass_confirmation: '',
                            lastname: '',
                            firstname: ''
                        };
                        $scope.legal_guardian = {
                            field_nom: '',
                            field_prenom: '',
                            field_civilite: '',
                            field_date_de_naissance: '',
                            mail: '',
                            field_tel_portable: ''
                        }
                        $scope.other_legal_guardian = {
                            field_nom: '',
                            field_prenom: '',
                            field_date_de_naissance: '',
                            mail: '',
                            field_tel_portable: ''
                        }

                        $scope.create = function (isValid) {
                            if (isValid) {
                                $scope.loading = true;
                                // create account then redirect to account form to fill missing information
                                $drupal.createAccount({
                                    email: $scope.user.email,
                                    pass: $scope.user.pass,
                                    lastname: $scope.user.lastname,
                                    firstname: $scope.user.firstname,
                                    birth_date: moment($scope.user.birth_date, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD"),
                                    legal_guardian: {
                                        field_nom: $scope.legal_guardian.field_nom,
                                        field_prenom: $scope.legal_guardian.field_prenom,
                                        field_date_de_naissance: $scope.legal_guardian.field_date_de_naissance ? moment($scope.legal_guardian.field_date_de_naissance, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD") : '',
                                        mail: $scope.legal_guardian.mail,
                                        salutation: $scope.legal_guardian.field_civilite,
                                        field_tel_portable: $scope.legal_guardian.field_tel_portable,
                                    },
                                    other_legal_guardian: {
                                        field_nom: $scope.other_legal_guardian.field_nom,
                                        field_prenom: $scope.other_legal_guardian.field_prenom,
                                        field_date_de_naissance: $scope.legal_guardian.field_date_de_naissance ? moment($scope.other_legal_guardian.field_date_de_naissance, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD") : '',
                                        mail: $scope.other_legal_guardian.mail,
                                        field_tel_portable: $scope.other_legal_guardian.field_tel_portable,
                                    }
                                }).then(function (result) {
                                    if (result.code === 0) {
                                        // retrieve current session
                                        return $profile.claim().then(function (result) {
                                            if (result.authenticated) {
                                                // redirect to new user form to complete subscription
                                                $state.go('order.user');
                                            } else {
                                                // TODO: add specific message if api provide it (leave empty for default message; see below)
                                                throw {};
                                            }
                                        });
                                    } else {
                                        // catch
                                        throw { data: { code: 9, message: result.message } };
                                    }
                                }).catch(function (error) {
                                    // errors handler
                                    if (error.data && error.data.code === 1) {
                                        angular.merge($scope.errors, { message: $filter('translate')('account.emailAlreadyExists') });
                                    } else if (error.data && error.data.message) {
                                        angular.merge($scope.errors, { message: error.data.message });
                                    } else {
                                        angular.merge($scope.errors, { message: $filter('translate')('server.notResponding') });
                                    }
                                }).finally(function () {
                                    $scope.loading = false;
                                });
                            }
                        };
                        utils.calendarTrad()
                        $scope.initDatepicker = function(){
                            utils.calendarTrad()
                        }
                    }],
                    templateUrl: 'src/views/order/order_login.html'
                }
            }
        })
        .state('order.user', {
            url: '/' + urls.user.fr, // TODO : when multilang, change this to something dynamic
            params: {
                existing: null,
                errorMessage: null,
            },
            resolve: {
                creationCondition: ['$q', 'drupal', 'auth', 'profile', function ($q, $drupal, auth, $profile) {
                    var deferred = $q.defer();
                    if ($profile.authorization.authenticated) {
                        if ($profile.isFullfilled()) {
                            // prepare rerouting (see app.js)
                            deferred.reject({ status: 'ORDER_LOGIN__ALREADY' });
                        } else {
                            // missing account info : display form
                            deferred.resolve();
                        }
                    } else {
                        // no user authenticated
                        deferred.reject({ status: 'ORDER_LOGIN__NEEDED' });
                    }
                    return deferred.promise;
                }]
            },
            views: {
                content: {
                    controller: ['$scope', '$rootScope', '$filter', '$state', '$stateParams', '$document', 'profile', '$q', 'lodash', 'cart', 'tools', 'moment', 'formPattern', 'utils', function ($scope, $rootScope, $filter, $state, $stateParams, $document, $profile, $q, lodash, $cart, tools, moment, formPattern, utils) {
                        $rootScope.titlePanel = {
                            title: $filter('translate')('order.identification'),
                            subtitle: ''
                        };
                        $scope.formPattern = formPattern;
                        $scope.dateRegex = new RegExp("^(?:(?:31(\\/)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/)(?:0?[1,3-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$");

                        $scope.member = $profile.info;
                        $scope.products = $cart.products;

                        $scope.errors = {
                            message: $stateParams.errorMessage
                        };

                        $scope.loading = false;

                        // civility/delivery fields configuration
                        $scope.civilityLabels = [
                            { text: $filter('translate')('form.male'), value: 'M.' },
                            { text: $filter('translate')('form.female'), value: 'Mme' }
                        ];
                        $scope.deliveryLabels = [
                            { text: $filter('translate')('form.yes'), value: true },
                            { text: $filter('translate')('form.no'), value: false }
                        ];
                        $scope.membershipLabels = {
                            placeholder: $filter('translate')('account.idMemberFormat'),
                            info: $filter('translate')('account.idMemberInfo'),
                            button: $filter('translate')('account.idMemberButton')
                        };

                        // TODO: get from config
                        $scope.cnil_message = 'Les informations qui vous sont demandées ne seront utilisées que par les Glénans dans le cadre de la gestion des adhérents et de la transmission de documents informatifs. Elles ne seront en aucun cas transmises à des tiers (sauf accord de votre part). Conformément à a loi «Informatique et Libertés» du 6 aoüt 2004, vous disposez d’un droit d’accès, de modification, de rectification et de suppression des données qui vous concernent.';

                        // form model
                        $scope.user = {
                            deliveryChoice: true,
                            civility: '',
                            firstname: angular.copy($scope.member.field_prenom),
                            lastname: angular.copy($scope.member.field_nom),
                            birth_date: $filter('date')(new Date($scope.member.field_date_de_naissance), 'shortDate'),
                        };

                        // form watcher for ggPlaces
                        $scope.$watchCollection('user.search_address', function (value) {
                            if (value && value.address_components) {
                                var formated = tools.formatGAddress(value);
                                if (formated.address) {
                                    $scope.user.address = formated.address;
                                    $scope.user.postal_code = formated.postal_code;
                                    $scope.user.city = formated.city;
                                    $scope.user.country = formated.country;
                                }
                            }
                        });

                        $scope.$watchCollection('user.search_addressDelivery', function (value) {
                            if (value && value.address_components) {
                                var formated = tools.formatGAddress(value);
                                if (formated.address) {
                                    $scope.user.addressDelivery = formated.address;
                                    $scope.user.postal_codeDelivery = formated.postal_code;
                                    $scope.user.cityDelivery = formated.city;
                                    $scope.user.countryDelivery = formated.country;
                                }
                            }
                        });

                        $scope.scrolltoForm = function () {
                            var element = angular.element(document.getElementById('memberForm'));
                            $document.scrollToElement(element, 30, 250);
                        };

                        // form submit handler
                        $scope.createUser = function () {
                            $scope.userForm.pending = true;

                            if ($scope.userForm.$valid) {
                                $q.resolve()
                                    .then(function () {
                                        // update user infol
                                        var data = angular.copy($scope.user);
                                        data.birth_date = moment($scope.user.birth_date, ["DD/MM/YYYY", "YYYY-MM-DD"]).format("YYYY-MM-DD");
                                        return $profile.amend(lodash.pick(data, ['civility', 'firstname', 'lastname', 'birth_date', 'nationality', 'mobile', 'phone', 'address', 'postal_code', 'city', 'country']));
                                    })
                                    .then(function () {
                                        // profile updated
                                        if ($scope.user.deliveryChoice) {
                                            // we store delivery information
                                            angular.copy(lodash.pick(angular.copy($scope.user), ['addressDelivery', 'postal_codeDelivery', 'cityDelivery', 'countryDelivery']), $profile.delivery);
                                        }
                                        $state.go('order.participants');
                                    })
                                    .catch(function (error) {
                                        $scope.userForm.pending = false;
                                        $scope.scrolltoForm();
                                    });
                            } else {
                                $scope.userForm.pending = false;
                                $scope.scrolltoForm();
                            }
                        };

                        utils.calendarTrad();
                    }],
                    templateUrl: 'src/views/order/order_newuser.html'
                }
            }
        });
}]);
